var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.link.external
    ? _c(
        "a",
        {
          staticClass: "select-none",
          class: _vm.classes,
          attrs: { href: _vm.link.uri, target: "_blank" }
        },
        [_vm._v(_vm._s(_vm.link.text))]
      )
    : _c(
        "router-link",
        {
          staticClass: "select-none",
          class: _vm.classes,
          attrs: { to: { name: _vm.link.uri, hash: _vm.link.hash } }
        },
        [_vm._v(_vm._s(_vm.link.text))]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }